import { privateApi } from 'api'
import { AxiosResponse } from 'axios'
import {
  IAdminAddRefundTransactionRequest,
  IAdminCreateSellerTransactionRequest,
  IAdminTransactionsRequest,
  IAdminTransactionsResponse,
  IOrderTransactionsResponse
} from 'models/transaction'

export const transactionsApi = {
  getTransactions({
    skip,
    limit,
    order_id,
    seller_id,
    type,
    sum,
    from,
    to,
    status
  }: IAdminTransactionsRequest): Promise<
    AxiosResponse<IAdminTransactionsResponse>
  > {
    const params = new URLSearchParams()
    params.append('skip', String(skip))
    params.append('limit', String(limit))
    params.append('order_id', order_id ?? '')
    params.append('seller_id', seller_id ?? '')
    params.append('type', type ?? '')
    params.append('sum', sum ?? '')
    params.append('from', from ?? '')
    params.append('to', to ?? '')

    if (Array.isArray(status)) {
      status.forEach((item) => params.append('status', item))
    } else if (status) {
      params.append('status', status)
    }

    return privateApi.get<IAdminTransactionsResponse>(
      `admin/transactions?${params.toString()}`
    )
  },
  getOrderTransactions(orderId: string): Promise<AxiosResponse<IOrderTransactionsResponse>> {
    return privateApi.get<IOrderTransactionsResponse>(`admin/order/transactions/${orderId}`)
  },
  createTransaction(sellerId: string, data: IAdminCreateSellerTransactionRequest): Promise<AxiosResponse> {
    return privateApi.post(`admin/transactions/${sellerId}`, data)
  },
  createRefundOrderTransaction(orderId: string, data: IAdminAddRefundTransactionRequest): Promise<AxiosResponse> {
    return privateApi.post(`admin/order/add/transaction/${orderId}`, data)
  }
}
